/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * Event helper class
 **/
define([], function(){

	class ContentUtil {
		/**
		 * Recursively walk the content and it's parent to find the page content.
		 * @param {ContentAPI} content
		 * @param {String} [type='page'] the content type.
		 * @returns {ContentAPI} page content. If the type can not be found, returns null
		 */
		static getPageContent(content, type = 'page') {
			let pageContent = null;
			while(content) {
				if (type && content.getType() === type) {
					pageContent = content;
				}
				content = content.getContainer();
			}
			return pageContent;
		}
	}
	return ContentUtil;
});
